import React, { useEffect, useState } from 'react'
import Text from '../../../components/text/Text'
import './RequestProforma.css'

import routes from '../../../router/routes'
import { useNavigate } from 'react-router-dom'
import {
    getBillingInfo,
    getUninvoicedMovements,
    requestProforma,
} from '../../../services/billing'
import { useLoadingContext } from '../../../context/spinnerContext'
import ModalComponent from '../../../components/modal/ModalComponent'

import alert from '../../../assets/icons/icons-error-circle.png'
import check from '../../../assets/icons/icons-success.png'
import error from '../../../assets/icons/icons-error.png'

import arrowBack from '../../../assets/icons/icons-arrow-back.svg'
import rotate from '../../../assets/icons/icons-rotate-right.png'
import checkCalendar from '../../../assets/icons/icons-calendar.png'
import calendar from '../../../assets/icons/icons-calendar-check.png'
import chevronRight from '../../../assets/icons/icons-arrow-right.svg'
import moment from 'moment'
import { track } from '../../../ClevertapWrapper'
import { clevertapEvents } from '../../../labels'
import { format } from 'date-fns'
import { isAdmin } from '../../../Utils/Profile'

interface IMovement {
    fecha: string
    autorizacion: string
    monto: string
}

interface ITransactionData {
    cantTx: string
    monto: string
}
interface IPreviousTransacionData {
    cantTx: string
    monto: string
}
interface IDataBilling {
    comisionAvance: number
}

type PROFORMA_DATE_TYPE = 'YESTERDAY' | 'SPECIFIC_DATE'
export default function RequestProformaScreen() {
    const navigation = useNavigate()
    const loadingContext = useLoadingContext()
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [proformaMadeModal, setProformaMadeModal] = useState(false)

    const [proformaDate, setProformaDate] = useState<PROFORMA_DATE_TYPE>()
    // usar sEstablecimiento aca: const resp = await getUninvoicedMovements('28464')

    const sEstablecimiento = user?.sEstablecimiento
    const [movements, setMovements] = useState([])

    const [showModal, setShowModal] = useState(false)
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [showAlertModal, setShowAlertModal] = useState(false)

    const [transacionData, setTransacionData] =
        useState<ITransactionData | null>()
    const [selectedMovement, setSelectedMovement] = useState<IMovement | null>(
        null
    )
    const [peviousTransacionData, setPreviousTransacionData] =
        useState<IPreviousTransacionData | null>(null)

    const [dataBilling, setDataBilling] = useState<IDataBilling | null>(null)

    const communicationChannelEventParms = {
        pageName: 'RequestProformaScreen',
        pageURL: `${routes.billing}/${routes.requestProforma}`,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }

    const navigate = useNavigate()
    const handleGoBack = () => {
        navigate(`/${routes.billing}`)
    }

    const renderErrorModal = () => {
        return (
            <ModalComponent
                show={showErrorModal}
                handleClose={() => setShowErrorModal(false)}
                icon={true}
                modalStyle="error-modal-style"
            >
                <div className="modal-container">
                    <img src={error} className="modal-img" />

                    <Text
                        label="Los movimientos no pudieron ser"
                        color={'#000000'}
                    />
                    <Text label="proformados." color={'#000000'} />
                    <Text
                        label="Si el problema persiste, intenta"
                        color={'#000000'}
                    />
                    <Text label="tarde." color={'#000000'} />

                    <button
                        className="modal-button-style"
                        onClick={() => {
                            setShowErrorModal(false)
                        }}
                    >
                        <Text
                            label="Solicitar proforma"
                            fontSize={14}
                            fontWeight={600}
                            fontFamily={'Montserrat'}
                        />
                    </button>
                </div>
            </ModalComponent>
        )
    }
    const renderProformaMadeModal = () => {
        return (
            <ModalComponent
                show={proformaMadeModal}
                handleClose={() => setProformaMadeModal(false)}
                icon={true}
                modalStyle="success-modal-style"
            >
                <div className="modal-container">
                    <img src={check} className="modal-img" />

                    <Text
                        label="Movimientos proformados con éxito"
                        color={'#000000'}
                    />

                    <button
                        className="modal-button-style"
                        onClick={() => {
                            setProformaMadeModal(false)
                            navigate(`/${routes.billing}/${routes.billingMain}`)
                        }}
                    >
                        <Text
                            label="Ir a histórico de facturación"
                            fontSize={14}
                            fontWeight={600}
                            fontFamily={'Montserrat'}
                        />
                    </button>
                </div>
            </ModalComponent>
        )
    }

    const handleProformaRequest = () => {
        loadingContext?.onOpen()

        requestProforma(moment(new Date()).format('DD-MM-yyyy'))
            .then(() => {
                setProformaMadeModal(true)
            })
            .catch(() => {
                setShowErrorModal(true)
            })
            .finally(loadingContext?.onClose)
    }

    const getmovementsInfo = async () => {
        try {
            loadingContext?.onOpen()
            const resp = await getUninvoicedMovements(sEstablecimiento)

            loadingContext?.onClose()

            const movements = resp.body.data.movements
            const transactionDataTmp = resp.body.data.totalesAyer
            const yesterdayDataTmp = resp.body.data.totalesAyer

            setMovements(movements)
            setTransacionData(transactionDataTmp)
            setPreviousTransacionData(yesterdayDataTmp)
        } catch (err) {
            loadingContext?.onClose()
            console.error('Error al cargar movimientos sin facturar:', err)
        }
    }

    useEffect(() => {
        getmovementsInfo()
    }, [])

    const getInfo = async () => {
        try {
            loadingContext?.onOpen()
            const resp = await getBillingInfo(sEstablecimiento)
            const info = resp.body.data
            setDataBilling(info)
        } catch (err) {
            console.error('Error al cargar el porcentaje de comision:', err)
        } finally {
            loadingContext?.onClose()
        }
    }

    useEffect(() => {
        getInfo()
    }, [])

    const movementDetailModal = () => {
        const formatedDate = selectedMovement?.fecha
            ? moment(selectedMovement.fecha, 'DD-MM-YYYY HH:mm:ss').format(
                  'DD-MM-YYYY'
              )
            : ''
        return (
            <ModalComponent
                show={showDetailModal}
                handleClose={() => setShowDetailModal(false)}
                icon={true}
                modalStyle="modal-style"
                title="Detalle"
                titleMarginLeft={20}
            >
                <div className="detail-modal-container">
                    <div className="flex-direction-row">
                        <Text
                            label={'Fecha: '}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={formatedDate}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'Tipo TRX:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={'Otros'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'N* autorización:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.autorizacion}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'Monto:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={`$ ${selectedMovement?.monto}`}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                </div>
            </ModalComponent>
        )
    }
    const alertModal = () => {
        return (
            <ModalComponent
                show={showAlertModal}
                handleClose={() => setShowAlertModal(false)}
                icon={true}
                modalStyle="alert-modal-style"
            >
                <div className="alert-modal-container">
                    <img src={alert} className="alert-img" />

                    <div className="flex-direction-row">
                        <Text
                            label="El tipo de pago "
                            color={'#656565'}
                            marginRight={2}
                        />
                        <Text
                            label="(pronto pago o pago"
                            fontSize={16}
                            fontWeight={700}
                            color={'#656565'}
                        />
                    </div>

                    <div className="flex-direction-row">
                        <Text
                            label="normal"
                            fontSize={16}
                            fontWeight={700}
                            color={'#656565'}
                        />
                        <Text
                            label=") debe ser informado en el"
                            color={'#656565'}
                        />
                    </div>

                    <Text
                        label="detalle factura de compra."
                        color={'#656565'}
                    />

                    <button
                        className="alert-modal-button-style"
                        onClick={() => {
                            if (proformaDate === 'SPECIFIC_DATE') {
                                navigation(`${routes.calendar}`)
                            } else {
                                handleProformaRequest()
                            }
                            setShowAlertModal(false)

                            setProformaDate(undefined)
                        }}
                    >
                        <Text label="Aceptar" fontSize={14} fontWeight={600} />
                    </button>
                </div>
            </ModalComponent>
        )
    }
    const requestProformaModal = () => {
        return (
            <ModalComponent
                show={showModal}
                handleClose={() => setShowModal(false)}
                icon={true}
                modalStyle="modal-style"
                title="Solicitud de proforma"
                titleMarginLeft={28}
            >
                <div className="card-container card-container-proforma">
                    <div
                        className="card-style"
                        onClick={() => {
                            setShowModal(false)
                            setShowAlertModal(true)
                            setProformaDate('YESTERDAY')
                        }}
                    >
                        <img
                            src={calendar}
                            className="modal-icon-style"
                            onClick={handleGoBack}
                        />
                        <Text
                            label="Generar proforma con los consumos hasta el día anterior."
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                        />
                        <img src={chevronRight} className="chevron-style" />
                    </div>
                    <div
                        className="card-style"
                        onClick={() => {
                            setShowModal(false)
                            setShowAlertModal(true)
                            setProformaDate('SPECIFIC_DATE')
                        }}
                    >
                        <img
                            src={checkCalendar}
                            className="modal-icon-style"
                            onClick={handleGoBack}
                        />

                        <Text
                            label="Generar proforma con los consumos de una fecha específica en el pasado."
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                        />
                        <img src={chevronRight} className="chevron-style" />
                    </div>
                </div>
            </ModalComponent>
        )
    }
    const renderTransactionInfo = () => {
        return (
            <div className="transaction-container">
                <div className="flex-direction-row">
                    <div
                        style={{
                            width: 200,
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div className="grid-item">
                            <div>
                                <Text
                                    label="Número"
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#656565'}
                                />

                                <Text
                                    label="transacciones"
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#656565'}
                                />
                                <Text
                                    label={transacionData?.cantTx}
                                    fontSize={12}
                                    fontWeight={400}
                                    color={'#000000'}
                                    marginTop={10}
                                />
                            </div>
                        </div>
                        <div className="grid-item">
                            <Text
                                label="Monto"
                                fontSize={12}
                                fontWeight={600}
                                color={'#656565'}
                            />
                            <Text
                                label={`$ ${transacionData?.monto}`}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                marginTop={20}
                            />
                        </div>
                    </div>
                    <div className="transaction-info-container">
                        <Text
                            label="Cierre para proforma:"
                            fontSize={12}
                            fontWeight={600}
                            color={'#000000'}
                            lineHeight={2}
                        />
                        <div className="flex-direction-row">
                            <Text
                                label="N° Transacciones al “día anterior”"
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                lineHeight={2}
                                marginRight={60}
                            />
                            <Text
                                label={peviousTransacionData?.cantTx}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                lineHeight={2}
                            />
                        </div>
                        <div className="flex-direction-row">
                            <Text
                                label="Monto al “día anterior”:"
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                lineHeight={2}
                                marginRight={112}
                            />
                            <Text
                                label={`$ ${peviousTransacionData?.monto}`}
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                lineHeight={2}
                            />
                        </div>
                        <div>
                            <Text
                                label="¡Importante! Las proformas se generan con la información disponible"
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                lineHeight={2}
                            />
                            <Text
                                label="hasta el día anterior a tu solicitud."
                                fontSize={12}
                                fontWeight={400}
                                color={'#000000'}
                                lineHeight={2}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    const openDetailModal = (
        fecha: string,
        autorizacion: string,
        monto: string
    ) => {
        setSelectedMovement({ fecha, autorizacion, monto })
        setShowDetailModal(true)
    }
    return (
        <div className="request-proforma-screen-parent">
            <div className="request-proforma-screen-container">
                {renderErrorModal()}
                {renderProformaMadeModal()}
                <div className="proforma-title-container">
                    <div className="flex-direction-row">
                        <img
                            src={arrowBack}
                            className="iconContainer-sch"
                            onClick={handleGoBack}
                        />

                        <Text
                            label="Movimientos no facturados"
                            fontSize={20}
                            fontWeight={600}
                            color={'#656565'}
                            marginLeft={3}
                        />
                    </div>
                </div>

                {isAdmin() && (
                    <>
                        <div className="height" />
                        <Text
                            label="Pronto pago"
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={2}
                        />
                        <Text
                            label="El pago se realizará dentro de 48 hrs. hábiles una vez recibida la factura."
                            fontSize={14}
                            fontWeight={400}
                            color={'#656565'}
                        />
                        <div className="flex-direction-row">
                            <Text
                                label="Cobro de"
                                fontSize={14}
                                fontWeight={400}
                                color={'#656565'}
                                lineHeight={3}
                            />
                            <Text
                                label={`${Number(
                                    dataBilling?.comisionAvance
                                )}% `}
                                fontSize={14}
                                fontWeight={600}
                                color={'#656565'}
                                lineHeight={3}
                                marginLeft={2}
                                marginRight={3}
                            />
                            <Text
                                label="de comisión de avance + IVA, adicional a la comisión acordada con amiPASS."
                                fontSize={14}
                                fontWeight={400}
                                color={'#656565'}
                                lineHeight={3}
                            />
                        </div>

                        <div className="text-proforma-container">
                            <Text
                                label="Pago normal"
                                fontSize={14}
                                fontWeight={600}
                                color={'#656565'}
                                lineHeight={2}
                            />
                            <Text
                                label="El pago se realizará dentro de los siguientes 10 días continuos una vez recibida la factura."
                                fontSize={14}
                                fontWeight={400}
                                color={'#656565'}
                            />
                            <Text
                                label="Se cobrará la comisión acordada con amiPASS."
                                fontSize={14}
                                fontWeight={400}
                                color={'#656565'}
                                lineHeight={3}
                            />
                        </div>
                    </>
                )}

                {isAdmin() && (
                    <div className={'centered'}>
                        <button
                            className={
                                movements.length !== 0
                                    ? 'request-proforma-button-style pointer'
                                    : 'button-disabled-style'
                            }
                            disabled={movements.length === 0}
                            onClick={() => {
                                setShowModal(true)
                                track(
                                    clevertapEvents.amiposweb_administratunegocio_facturacionypagos_movimientosnofacturados_solicitarproforma,
                                    communicationChannelEventParms
                                )
                            }}
                        >
                            <Text
                                label="Solicitar proforma"
                                fontSize={14}
                                fontWeight={600}
                            />
                        </button>
                    </div>
                )}
                {movements.length !== 0 && renderTransactionInfo()}

                <Text
                    label="Detalle"
                    fontSize={14}
                    fontWeight={600}
                    color={'#000000'}
                    marginTop={50}
                />

                <div
                    className="grid-container"
                    style={{ height: 300, overflowY: 'auto' }}
                >
                    <div className="grid-item">
                        <Text
                            label="Fecha"
                            fontSize={12}
                            fontWeight={600}
                            color={'#000000'}
                            lineHeight={2}
                        />
                    </div>
                    <div className="grid-item grid-item-2">
                        <Text
                            label="Nº autorización"
                            fontSize={12}
                            fontWeight={600}
                            color={'#000000'}
                            lineHeight={2}
                        />
                    </div>
                    <div className="grid-item grid-item-3">
                        <Text
                            label="Monto"
                            fontSize={12}
                            fontWeight={600}
                            color={'#000000'}
                            lineHeight={2}
                            marginRight={20}
                        />
                    </div>

                    {movements.map(({ fecha, autorizacion, monto }, index) => {
                        const formatedDate = moment(
                            fecha,
                            'DD-MM-YYYY HH:mm:ss'
                        ).format('DD-MM-YYYY')

                        return (
                            <React.Fragment key={index}>
                                <div className="grid-item">
                                    <Text
                                        label={formatedDate}
                                        fontSize={12}
                                        fontWeight={400}
                                        color={'#000000'}
                                    />
                                </div>
                                <div
                                    className="grid-item grid-item-2"
                                    onClick={() =>
                                        openDetailModal(
                                            fecha,
                                            autorizacion,
                                            monto
                                        )
                                    }
                                >
                                    <Text
                                        label={autorizacion}
                                        fontSize={12}
                                        fontWeight={400}
                                        color={'#000000'}
                                    />
                                </div>
                                <div className="grid-item grid-item-3">
                                    <Text
                                        label={`$ ${monto}`}
                                        fontSize={12}
                                        fontWeight={400}
                                        color={'#000000'}
                                    />
                                </div>
                            </React.Fragment>
                        )
                    })}

                    {requestProformaModal()}
                    {movementDetailModal()}
                    {alertModal()}
                </div>
                {movements.length === 0 && (
                    <div className="no-movements-style-container">
                        <img src={rotate} className="rotate-img" />
                        <Text label="No se registran movimientos." />
                    </div>
                )}
            </div>
        </div>
    )
}
